<template>
  <data-table
    :headers="headers"
    :data="items"
    :hide-edit="true"
    :hide-delete="true"
    :hide-table-bottom="true"
  />
</template>

<script>
import DataTableStateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableStateColumn.vue';
import DataTable from '@/app/arch/components/data-table/DataTable.vue';

export default {
  name: 'AddressTable',
  components: { DataTable },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    headers: [
      {
        text: 'CEP',
        value: 'postalCode',
      },
      {
        text: 'Logradouro',
        value: 'street',
      },
      {
        text: 'Número',
        value: 'number',
      },
      {
        text: 'Bairro',
        value: 'neighborhood',
      },
      {
        text: 'Complemento',
        value: 'complement',
      },
      {
        text: 'Cidade',
        value: 'city',
      },
      {
        text: 'Estado',
        value: 'state',
        component: DataTableStateColumnVue,
      },
    ],
  }),
  computed: {
    items() {
      return this.value;
    },
  },
};
</script>
